/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';
import {SurveyRespondentModel} from "../../models/survey-respondent-model";

export interface SurveyRespondentDetailsGetParams {
    accountGuid: string;
    surveyRespondentGuid: string;
}

export function surveyRespondentsQuestionnairesGet(
    http: HttpClient, rootUrl: string, params: SurveyRespondentDetailsGetParams, headers: HttpHeaders, context?: HttpContext
): Observable<StrictHttpResponse<SurveyRespondentModel>> {

    const rb = new RequestBuilder(rootUrl, surveyRespondentsQuestionnairesGet.PATH, 'get');
    for (let headerKey of headers.keys()) {
        rb.header(headerKey, headers.get(headerKey));
    }

    rb.path('surveyRespondentGuid', params.surveyRespondentGuid, {"style":"simple"});

    return http.request(
        rb.build({ responseType: 'json', accept: '*/*', context })
    ).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<SurveyRespondentModel>;
        })
    );
}

surveyRespondentsQuestionnairesGet.PATH = '/api/v1/survey-respondents/{surveyRespondentGuid}/details';
